import { render, staticRenderFns } from "./ContractAcceptance.vue?vue&type=template&id=0c475eb4"
import script from "./ContractAcceptance.vue?vue&type=script&lang=js"
export * from "./ContractAcceptance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports